import { ListGroup } from 'react-bootstrap';
import { CompanyNode } from '../models/company';
import { DepartmentNode } from '../models/department';
import { isCompanyNode } from '../utils/common';
import { DepartmentMenuItem } from './DepartmentMenuItem';

export interface DepartmentMenuProps {
  data: Array<CompanyNode> | Array<DepartmentNode>;
}

export function DepartmentMenu({ data }: DepartmentMenuProps) {
  return (
    <ListGroup>
      {data.map(function (item) {
        return (
          <DepartmentMenuItem
            key={isCompanyNode(item) ? item.company_cd : (item as DepartmentNode).department_cd}
            data={item}
          />
        );
      })}
    </ListGroup>
  );
}
